import PropTypes from "prop-types";
import {MoreVertical} from "react-feather";
import './CampaignCard.css'
import ALink from "../../../../lib/components/Link/ALink";

import React from "react";

import CampaignBase from "./CampaignBase";
import shortid from "shortid";
import {
  Card, CardActionArea, CardContent, IconButton
} from "@mui/material";
import Menu from "../menu/Menu";
import {type} from "@testing-library/user-event/dist/type";

class CampaignCard extends CampaignBase {

  constructor(props) {
    super(props);
    this.storageId = 'CampaignCard_' + shortid();
  }

  render() {
    let campaign = this.props.campaign;
    if (this.state.image === null) {
      let campaignImageUrl = campaign.thumbnail ? campaign.thumbnail : this.defaultImages[(this.props.index % 7 + 1)];
      this.state.image = <img alt='Thumbnail' src={campaignImageUrl} onClick={(e) => this.onCardClick(e)}
                              className='object-cover h-full w-full'/>;
    }

    let formattedDate = 'undefiniert';
    if (campaign.eventDateTime != null) {
      formattedDate = new Intl.DateTimeFormat('de-CH', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(campaign.eventDateTime);
    }

    return <>
      <Card sx={{maxWidth: 260, minWidth: 260, borderRadius: 5, position: 'relative'}} >
        <CardActionArea>
          <div className='h-[250px] overflow-hidden cursor-pointer'>
            {this.state.image}
          </div>
        </CardActionArea>
        <p className='text-sm text-center pt-0.5 text-cn-color-secondary'>{formattedDate}</p>
        <IconButton className='campaign-card-more-button' onClick={(e) => this.onMoreButtonClick(e)}>
          <MoreVertical className='bg-cn-color-white text-cn-color-black rounded-full'/>
        </IconButton>
        <Menu
          open={Boolean(this.state.campaignMoreMenuAnchorEl)}
          anchorEl={this.state.campaignMoreMenuAnchorEl}
          onClose={() => this.setState({campaignMoreMenuAnchorEl: null})}>
          {this.campaignMoreMenuItems}
        </Menu>
        {this.createStatusIcon()}
        <Menu
          open={Boolean(this.state.statusMenuAnchorEl)}
          anchorEl={this.state.statusMenuAnchorEl}
          onClose={() => this.setState({statusMenuAnchorEl: null})}>
          {this.statusMenuItems}
        </Menu>
        <CardActionArea sx={{borderRadius: 0}} onClick={(e) => this.onCardClick(e)}>
          <CardContent>
            <h4>{campaign.name}</h4>
            <p className='text-sm text-cn-color-gray-500 mt-1 h-24 overflow-hidden break-normal'>
              {campaign.description}
            </p>
            <p>Erstellt von: {campaign.createdBy}</p>
          </CardContent>
        </CardActionArea>
        <ALink className='mb-3 px-2' href={campaign.baseUrl} target='_blank' title={campaign.baseUrl}/>
      </Card>
      {this.createUpdateCampaignDialog()}
      {this.createDeleteCampaignDialog()}
    </>;

  }
}

CampaignCard.propTypes = {
  campaign: PropTypes.object, onCardClick: PropTypes.func, reloadCampaigns: PropTypes.func, index: PropTypes.number
}
export default CampaignCard;